<template>
  <div
      class="stateInsert"
  >
    <div class="row">
      <div class="col-md-7">
        <h5 class="font-weight-normal mt-3">
          Where are your facilities/offices located?
        </h5>
      </div>
      <div class="stateContainer col-md-5">
        <div class="form">
          <div class="form-group">
            <select
                name="State"
                class="form-control form-control-lg"
                required="required"
                v-model="selectedState"
                @change="onStateSelectChange"
            >
              <option value="NA" selected="true" disabled="disabled">
                -- Choose State --
              </option>
              <option
                  v-for="item in stateOptions"
                  :value="item"
                  :key="item.ID"
              >
                {{ item.Name }}
              </option>
            </select>
            <span v-if="state.locations[id].stateErrors" id="StateError" class="help-block">Please select a state.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-7">
        <h5 class="font-weight-normal mt-3">
          How many employees in your organization?
        </h5>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <input
              type="number"
              name="Employees"
              :id="'employee-'+id"
              class="form-control form-control-lg"
              placeholder="# of Employees"
              maxlength="15"
              data-toggle="tooltip"
              data-placement="top"
              title="Please enter a number with no commas."
              data-original-title="Please enter a number with no commas."
              v-model="employeeCount"
              @change="onEmployeeCountChange"
          />
          <span v-if="state.locations[id].employeeErrors" id="EmployeesError" class="help-block">Please enter a number of employees greater than 0.</span>
        </div>
      </div>
    </div>
    <hr class="mb-4"/>
  </div>
</template>

<script>
import store from '../store.js';
import _ from 'lodash';
import {StateData} from '../data.js';

export default {
  name: "StateSelector",
  props: ['id'],
  data() {
    return {
      state: store.state,
      selectedState: "NA",
      employeeCount: null,
    }
  },
  methods: {
    onStateSelectChange() {
      store.updateLocationState(this.id, this.selectedState) 
    },
    onEmployeeCountChange(){
      store.updateLocationEmployeeCount(this.id, this.employeeCount);
    }
  },
  computed: {
    stateOptions() {
      let selectedStates = _.map(this.state.locations, location => location.state.ID);
      if(store.debug){
        console.log("currently selected states: ", selectedStates);
      }
      
      let filteredOptions = _.filter(StateData, x => !selectedStates.includes(x.ID) || x.ID === this.selectedState.ID);  
      
      if(store.debug){
        console.log("filtered state options: ", filteredOptions);
      }
      return filteredOptions;
    }
  },
  mounted () {
    if(store.debug)
      console.log("state-selector-store", store);
  }
}
</script>

<style scoped>

</style>